import Error from '../model/Error';
import JobMetaClub from '../dto/JobMetaClub';
import axios from 'axios';

export default class JobMetaClubRepository {
    static findForClubAndDatevExport(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/job-meta/datev-exports`)
                .then((response) => resolve(response.data.data.map((data) => JobMetaClub.fromDataAndDatevExport(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
